import React from "react";
import SectionHeading from "./SectionHeading";
import {
  Shield,
  Zap,
  Globe,
  Cpu,
  GitBranch,
  BarChart3,
} from "lucide-react";

const cards = [
  {
    title: "Security & Privacy",
    icon: Shield,
    description:
      "End-to-end encryption, GDPR compliance, and secure authentication built in from day one.",
  },
  {
    title: "Performance Optimization",
    icon: Zap,
    description:
      "Lightning-fast load times and smooth 60fps interactions for an exceptional user experience.",
  },
  {
    title: "Cross-Platform Reach",
    icon: Globe,
    description:
      "Reach iOS and Android users simultaneously with native-quality apps from a single codebase.",
  },
  {
    title: "AI & Smart Features",
    icon: Cpu,
    description:
      "Integrate machine learning, chatbots, and AI-driven personalization to stay ahead.",
  },
  {
    title: "Seamless Integrations",
    icon: GitBranch,
    description:
      "Connect with payment gateways, CRMs, analytics tools, and third-party APIs effortlessly.",
  },
  {
    title: "Analytics & Insights",
    icon: BarChart3,
    description:
      "Real-time dashboards and user behavior tracking to power data-driven decisions.",
  },
];

export default function KeyConsideration() {
  return (
    <section className="bg-[#F8F8FB] py-20 px-6 border-t border-gray-200/60">
      <div className="max-w-7xl mx-auto">
        {/* Badge */}
        <div className="mb-12">
          <SectionHeading
            eyebrow="Key Considerations"
            title={<>Key Considerations for Custom <br /> Mobile Apps</>}
            description="We focus on essential pillars that ensure your app is secure, performant, and built to scale effortlessly."
            theme="light"
            titleClassName="text-slate-900"
            descriptionClassName="max-w-4xl mx-auto text-lg leading-relaxed"
          />
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-16">
          {cards.map((item, index) => {
            const Icon = item.icon;
            return (
              <div
                key={index}
                className="group bg-white border border-[#ECECEC] rounded-2xl p-8 hover:-translate-y-2 hover:shadow-xl transition-all duration-300"
              >
                <div className="w-12 h-12 rounded-xl bg-[#EBF2FF] text-[#355dff] flex items-center justify-center mb-6 group-hover:bg-[#355dff] group-hover:text-white transition duration-300">
                  <Icon size={22} />
                </div>
                <h3 className="text-xl font-bold text-[#111827] mb-3">
                  {item.title}
                </h3>
                <p className="text-gray-500 text-[14px] leading-7">
                  {item.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}